import { WebhookKey } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TWebhookRequest } from "../updateWebhook/updateWebhook.schema";
import { TWebhookResponse } from "./testWebhook.schema";

// TODO: Migrate remaining webhooks to this route
export const webhookKeyToLaForgeRoute: Partial<Record<WebhookKey, string>> = {
  [WebhookKey.TRANSACTION_RETURNED]: "/api/testTransactionReturnedWebhook",
  [WebhookKey.VERIFF_DECISION]: "/api/testVeriffDecisionWebhook",
  [WebhookKey.PERSONA_VERIFICATION]: "/api/testPersonaDecisionWebhook",
  [WebhookKey.WALLET_TRANSACTION]: "/api/testWalletTransactionWebhook",
};

export const testWebhook = (axios: IAxiosInstance) => {
  return async ({ testMode, url, webhookKey }: TWebhookRequest) => {
    const laForgeRoute = webhookKeyToLaForgeRoute[webhookKey];

    if (!laForgeRoute) {
      throw new Error(`Invalid webhook key: ${webhookKey}`);
    }

    const response = await axios.noRetry.post<IApiResponse<TWebhookResponse>>(
      laForgeRoute,
      {
        url,
        testMode,
      }
    );

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
